(() => {
  if (customElements.get('oilogic-quantity-selector')) return;

/*
 * <oilogic-quantity-selector> — dumb stepper, no network calls.
 * Dispatches oilogic:quantity:change (bubbles) with { key, quantity } so a
 * parent element (the cart drawer today, the product page later) can persist
 * the change via /cart/change.js.
 *
 * Expected markup:
 *   <oilogic-quantity-selector data-key="..." data-quantity="1" data-min="0">
 *     <button data-quantity-decrease>...</button>
 *     <span data-quantity-value>1</span>
 *     <button data-quantity-increase>...</button>
 *   </oilogic-quantity-selector>
 */
class OilogicQuantitySelector extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;

    this.valueEl = this.querySelector('[data-quantity-value]');
    this.decreaseBtn = this.querySelector('[data-quantity-decrease]');
    this.increaseBtn = this.querySelector('[data-quantity-increase]');

    this.min = parseInt(this.dataset.min, 10);
    if (Number.isNaN(this.min)) this.min = 0;

    this.quantity = parseInt(this.dataset.quantity, 10);
    if (Number.isNaN(this.quantity)) this.quantity = 1;

    this.decreaseBtn?.addEventListener('click', () => this.change(-1), { signal });
    this.increaseBtn?.addEventListener('click', () => this.change(1), { signal });
  }

  disconnectedCallback() {
    if (this.controller) this.controller.abort();
  }

  change(delta) {
    const next = Math.max(this.min, this.quantity + delta);
    if (next === this.quantity) return;

    this.quantity = next;
    if (this.valueEl) this.valueEl.textContent = this.quantity;
    this.setAttribute('data-busy', delta > 0 ? 'increase' : 'decrease');

    this.dispatchEvent(new CustomEvent('oilogic:quantity:change', {
      bubbles: true,
      composed: true,
      detail: { key: this.dataset.key, quantity: this.quantity },
    }));
  }
}

customElements.define('oilogic-quantity-selector', OilogicQuantitySelector);
})();
